import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 3.42rem;
  margin-left: 4.4rem;
  padding: 1rem 1.5rem;
  // border: 2px solid red;

  .table {
    font-size: 13px;
    font-weight: 500;

    .head {
      tr {
        th {
          font-size: 10px;
          color: #333;
        }
      }
    }
    .body {
      font-size: 13px;
      tr {
        td {
          color: #455a64;

          img {
            width: 28px;
            height: 28px;
          }

          button {
            display: flex;
            align-items: center;
            font-size: 13px;
            font-weight: 500;
            color: var(--azul-razio);
          }
        }
      }
    }
    .foot {
      tr {
        th {
          font-size: 10px;
          color: #333;
        }
      }
    }

    .campanhas-vazio {
      display: flex;
      justify-content: center;
      align-items: center;

      h1 {
        font-size: 20px;
        font-weight: 600;
      }
    }
  }

  // 760px
  @media (max-width: 47.5rem) {
    margin-top: 3.9rem;
    margin-left: 0;
  }
`;

export const HeaderContent = styled.header`
  flex: 1;
  display: flex;
  width: 100%;
  margin: 20px 0 50px;

  .btn-add-class {
    background-color: var(--azul-razio);
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 8px;
  }
`;
